(function($) {
    "use strict";

    if (!$('.list-page-resources').length) return;

    var _pager = new PHI.Pager();

    function _got_resources(d) {
        $('.loading-overlay').hide();

        if (!PHI.api.handleReturn(d)) return;

        var items = d.data ? d.data.items : [],
            total = d.data ? d.data.total_found : 0,
            pages = Math.ceil(total / PHI.api.PAGE_SIZE),
            list = $('#results-list');

        list.empty();

        _pager.render(total);

        if (0 === total) {
            $('#results-counts').text('No items found');

            return;
        }

        var local_last = _pager.offset() + PHI.api.PAGE_SIZE;

        if (local_last > total) local_last = total;

        $('#results-counts').text((_pager.offset() + 1) + '–' + local_last + ' of ' + total);

        var count = 0,
            item = null,
            currentRow = null,
            art = null,
            div = null,
            kick = null,
            a = null,
            img = null,
            h2 = null;
        for (var i = 0; i < items.length; i++) {
            item = items[i];

            if (0 === count % 2) {
                if (currentRow) list.append(currentRow);

                currentRow = $('<div class="content-grid-row list-page-results list-page-results-row">');
            }

            art = $('<article class="list-page-results-item list-page-results-item__resource">');
            art.addClass((0 === (count + 1) % 2) ? 'column-right' : 'column-left');

            // if (item.featured_image_url) {
            //     div = $('<div class="list-page-results-item__resource-image">');
            //     a = $('<a href="' + item.url + '">');
            //     img = $('<img src="' + item.featured_image_url + '">');
            //     img.prop('alt', item.title);

            //     a.append(img);
            //     div.append(a);
            //     art.append(div);
            // }

            div = $('<div class="kicker">');
            kick = $('<span class="type">');
            kick.text(item.subtype);

            div.append(kick);

            kick = $('<span class="date">');
            kick.text(item.published_formatted);
            div.append(kick);

            art.append(div);

            h2 = $('<h2>');
            a = $('<a href="' + item.url + '">');
            a.prop('title', item.title);
            a.text(PHI.get_title(item));
            h2.append(a);
            art.append(h2);

            if (item.short_description) {
                div = $('<div class="list-page-results-item__description">');
                div.text(PHI.get_short_description(item));
                art.append(div);
            } else h2.addClass('no-short-description');

            currentRow.append(art);
            count++;
        }

        // while (count % 3 !== 0) {

        //     art = $('<article class="list-page-results-item list-page-results-item__resource">');
        //     art.addClass((0 === (count + 1) % 3) ? 'column-third-last' : 'column-third');
        //     currentRow.append(art);
        //     count++;
        // }

        list.append(currentRow);
    }

    function _resource_filter(e) {
        var offset = 0;

        if (e) {
            if (e.params && 'unselect' === e.params._type) {
                $(e.target).val('');
                _pager.reset();
            } else if ('pagination' === e.type) offset = _pager.offset();
            else _pager.reset();
        }

        var search = $('#keyword').val(),
            type = $('#filter-type option:selected').text(),
            issue = $('#filter-issue option:selected').text(),
            from = $('#date-from').val(),
            to = $('#date-to').val(),
            expert = $('#filter-expert option:selected').text(),
            state = $('#filter-state option:selected').text(),
            phi_authored = $('#filter-phi-authored').is(":checked");

        $('.loading-overlay').show();

        PHI.api.getResources(search, type, issue, from, to, expert, state, phi_authored, offset, _got_resources);
    }

    function _process_incoming() {
        var hash = window.location.hash;

        if (!hash) return false;

        var p = null,
            k = null,
            t = null,
            f = null;

        hash = hash.substring(1);
        hash = hash.split('&');

        for (var i = 0; i < hash.length; i++) {
            p = hash[i].split('=');

            if (2 === p.length) {
                k = p[0];
                t = decodeURIComponent(p[1]);

                if ('search' === k) {
                    $('#keyword').val(t);

                    continue;
                }

                f =  $('#filter-' + k);

                if (f.length) {
                    var val = f.find('option:contains("' + t + '")').val();

                    if (!val) val = f.find('option[value="' + t + '"]').val();

                    if (val) {
                        f.val(val);
                        f.trigger('change');
                    }
                }
            }
        }

        _resource_filter(null);

        return true;
    }

    $(function() {
        $('.loading-overlay').show();

        $('.list-page-filter-clear a').click(function(e) {
            e.preventDefault();

            $('#keyword').val('');
            $('#filter-type,#filter-issue,#filter-expert,#filter-state').val('').trigger('change');
            $('#filter-phi-authored').prop('checked', false);

            $('.loading-overlay').show();

            _pager.reset();

            PHI.api.getResources(null, null, null, null, null, null, null, null, 0, _got_resources);

            return false;
        });

        $('#keyword').on('keydown', _.debounce(_resource_filter, 1000));

        $('#filter-type,#filter-issue,#filter-expert,#filter-state').on('select2:select', _resource_filter);
        $('#filter-type,#filter-issue,#filter-expert,#filter-state').on('select2:unselect', _resource_filter);
        $('#filter-phi-authored').change(_resource_filter);

        _pager.init('#pager-container', '.list-page-filter', _resource_filter);

        if (_process_incoming()) return;

        PHI.api.getResources(null, null, null, null, null, null, null, null, 0, _got_resources);
    });
})(jQuery);
